function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "conference speaker");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M436.27,511.68c1.07-2.16,2.85-3.86,4.33-5.75a8.33,8.33,0,0,1-.67.5,11.07,11.07,0,0,0-3,1.89,6.24,6.24,0,0,0-1.08,2.55l-2.55,9.9c.5-.63,1-1.25,1.51-1.87A17.5,17.5,0,0,1,436.27,511.68Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M677,518.37a11.33,11.33,0,0,1-1,3.23A45.14,45.14,0,0,1,674.34,534a37.58,37.58,0,0,0-1.05,5.19c-2.36,16.14-4.64,33-.61,48.64a5.86,5.86,0,0,1,1.53-2.5c2.66-3.27,3.71-7.54,4.5-11.68,4.15-21.8,3-44.06,2-66.33a7.39,7.39,0,0,0-2.18-1.65,20.28,20.28,0,0,1-.07,2.92A96.74,96.74,0,0,1,677,518.37Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M536.78,511.7A10.21,10.21,0,0,0,536,508a11.82,11.82,0,0,0-1.94-2.68l-2.16-2.46c-1.1,26.12-3.44,52.31,1.42,77.88.79,4.14,1.84,8.41,4.5,11.68a5.86,5.86,0,0,1,1.53,2.5c4-15.61,1.75-32.5-.61-48.64a37.58,37.58,0,0,0-1.05-5.19,49.59,49.59,0,0,1-1.19-20.15A47.06,47.06,0,0,0,536.78,511.7Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M549.16,456.58c2.89,4.75,4.69,10.4,6.31,15.78l.69,2.34c-.33-7.91-.49-15.81-.55-23.72-1.56,1.39-3.13,2.75-4.71,4.11Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M572.41,723.14a53.51,53.51,0,0,0-1.27-16.52c-.88-3.42-2.24-6.77-2.36-10.31a31.68,31.68,0,0,1,.86-7c4.11-20.9,5.88-42.89-.34-63.26-1.67-5.46-3.88-10.74-5.58-16.19a39.46,39.46,0,0,1-2.82,5.91,6.12,6.12,0,0,0-3.41-4,20.28,20.28,0,0,1-.07,2.92,96.74,96.74,0,0,1-1.39,9.74A9.93,9.93,0,0,1,554.8,628a8.3,8.3,0,0,1-3.22,2.66c.58,1.31,1.16,2.63,1.73,3.94l-4.17,1.28c2.74,6,.46,12.84-1,19.22-5.23,22.19-.52,45.89-3,68.32Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M557.27,405.68c1.07-2.16,2.85-3.86,4.33-5.75a8.33,8.33,0,0,1-.67.5,11.07,11.07,0,0,0-3,1.89,6.24,6.24,0,0,0-1.08,2.55l-2.55,9.9c.5-.63,1-1.25,1.51-1.87A17.5,17.5,0,0,1,557.27,405.68Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M657.78,405.7A10.21,10.21,0,0,0,657,402a11.82,11.82,0,0,0-1.94-2.68l-2.16-2.46c-1.08,25.72-3.36,51.52,1.22,76.72.81-2.72,1.63-5.44,2.44-8.17a83.33,83.33,0,0,1,4.81-13.08c-.47-4-1.05-8.07-1.63-12a37.58,37.58,0,0,0-1.05-5.19,49.59,49.59,0,0,1-1.19-20.15A47.06,47.06,0,0,0,657.78,405.7Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M614.17,602.28l-3.42,120.45,9-.1a376.29,376.29,0,0,1-2.16-44.15c0-4.29.15-8.62-.74-12.82-.63-2.93-1.73-5.74-2.33-8.67a51.92,51.92,0,0,1-.67-10.65Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M536.83,602.34c.14-.33.28-.66.41-1,.47-1.22.89-2.45,1.28-3.69a1,1,0,0,0-.08.14c-.79,1.3-1.65,2.55-2.54,3.77C536.22,601.82,536.53,602.07,536.83,602.34Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M264.78,467.7A10.21,10.21,0,0,0,264,464a11.82,11.82,0,0,0-1.94-2.68l-2.16-2.46c-1.1,26.12-3.44,52.31,1.42,77.88.79,4.14,1.84,8.41,4.5,11.68a5.86,5.86,0,0,1,1.53,2.5c4-15.61,1.75-32.5-.61-48.64a37.58,37.58,0,0,0-1-5.19,49.59,49.59,0,0,1-1.19-20.15A47.06,47.06,0,0,0,264.78,467.7Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M264.83,558.34c.14-.33.28-.66.41-1,.47-1.22.89-2.45,1.28-3.69a1,1,0,0,0-.08.14c-.79,1.3-1.65,2.55-2.54,3.77C264.22,557.82,264.53,558.07,264.83,558.34Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M221.17,664.28q-.88,31.35-1.78,62.69l4.29-.05c-.64-2.66-1.59-5.24-2.14-7.93a51.92,51.92,0,0,1-.67-10.65Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M285.42,724.68A8.3,8.3,0,0,1,282.2,722a9.93,9.93,0,0,1-1.23-3.65,96.74,96.74,0,0,1-1.39-9.74,20.28,20.28,0,0,1-.07-2.92,6.12,6.12,0,0,0-3.41,4A46.76,46.76,0,0,1,270.48,693c-.3,1-.61,2.1-1,3.14-2.08,6.19-5.1,12.18-5.7,18.69a37.07,37.07,0,0,0,1,11.67l19.86-.22C285,725.74,285.19,725.21,285.42,724.68Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M298.48,691.66c.39,1.24.81,2.47,1.28,3.69.13.33.27.66.41,1,.3-.27.61-.52.93-.77-.89-1.22-1.75-2.47-2.54-3.77A1,1,0,0,0,298.48,691.66Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M441.75,712.46a124.13,124.13,0,0,1-2.87-18.11q-2.38-22-4.76-44c-.05-.38-.09-.77-.13-1.15-.06.19-.11.38-.17.57-1.21,3.55-3.61,6.54-6,9.46s-5.38,5.94-8.89,5.08a9.55,9.55,0,0,1-3.81-2.35l-8-6.91c-1.58-1.36-3.15-2.72-4.71-4.11-.07,9.65-.29,19.29-.79,28.93-.16,3.05-.41,6.23-1.85,8.89a101.92,101.92,0,0,1,4.86,28.34c.07,2.61,0,5.22-.08,7.83l23.44-.26h.14l17.63-.19C444.29,720.54,442.81,716.56,441.75,712.46Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M402.15,612.9c.5.62,1,1.24,1.51,1.87l-2.55-9.9a6.24,6.24,0,0,0-1.08-2.55,11.07,11.07,0,0,0-3-1.89,8.33,8.33,0,0,1-.67-.5c1.48,1.89,3.26,3.59,4.33,5.75A17.5,17.5,0,0,1,402.15,612.9Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M431.14,569c.63,6.95,1,13.92,1.35,20.89s.71,13.76,1.06,20.64a102,102,0,0,1,3.7-15.7c-1.44-2.66-1.69-5.84-1.85-8.89-.5-9.64-.72-19.28-.79-28.93-1.53,1.37-3.08,2.71-4.64,4A56.24,56.24,0,0,1,431.14,569Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M298.29,640.23c-2.36,16.14-4.64,33-.61,48.64a5.86,5.86,0,0,1,1.53-2.5c2.66-3.27,3.71-7.54,4.5-11.68,4.86-25.57,2.52-51.76,1.42-77.88L303,599.27A11.82,11.82,0,0,0,301,602a10.21,10.21,0,0,0-.81,3.75,47.06,47.06,0,0,0,.31,9.19A49.59,49.59,0,0,1,299.34,635,37.58,37.58,0,0,0,298.29,640.23Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M659.9,722.19l7.84-.08c-4.18-24.08,1.85-49.93-3.83-74-.89-3.75-2-7.68-2.28-11.49-2,5.31-4.29,10.55-4.81,16.18-.91,9.73,3.67,19.05,5.37,28.68,2.34,13.27-.83,26.8-2.24,40.2C659.93,721.86,659.92,722,659.9,722.19Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M929.48,710.12c-9.08-27.06,0-57.22-6.57-85-1.51-6.38-3.79-13.27-1-19.22l-4.17-1.28c.57-1.31,1.15-2.63,1.73-3.94a10.35,10.35,0,0,1-2.24-1.54l-3.06,28.21a124.13,124.13,0,0,1-2.87,18.11c-1.73,6.65-4.54,13-6.55,19.55-5.37,17.56-4.78,36.32-1.89,54.55l30-.32C931.76,716.19,930.51,713.18,929.48,710.12Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M915.45,442.64l.08-.28.36-1.17a12.51,12.51,0,0,0-2.82-1.76,8.33,8.33,0,0,1-.67-.5C913.39,440.19,914.5,441.36,915.45,442.64Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M814.48,530.66c.39,1.24.81,2.47,1.28,3.69.13.33.27.66.41,1,.3-.27.61-.52.93-.77-.89-1.22-1.75-2.47-2.54-3.77A1,1,0,0,0,814.48,530.66Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M937.71,550.69c3.07-16.12,3.27-32.48,2.72-48.91a6.41,6.41,0,0,1-5.47,1.57l-.17-.05a42.74,42.74,0,0,1-1.45,7.74,37.58,37.58,0,0,0-1.05,5.19c-2.36,16.14-4.64,33-.61,48.64a5.86,5.86,0,0,1,1.53-2.5C935.87,559.1,936.92,554.83,937.71,550.69Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M493.07,724q0-7.86.1-15.73-.23,7.86-.44,15.73Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M1116.24,290.19q-1-5.65-2.37-11.11c-9.7-39.22-32.41-70.52-74-87.46q-5.35-2.18-11.12-4a189.09,189.09,0,0,0-26.76-6.4c-87.24-14.59-160.6-7.65-226.73,5.51-3.73.73-7.43,1.5-11.12,2.28-92.7,19.59-171.64,49.94-255.87,47.29-3.69-.11-7.4-.29-11.11-.53-36.72-2.44-74.6-11.43-115.17-30.55-47.95-22.59-96.71-15-140.7,11.9-24.83,15.16-48.14,36.48-68.93,62l-.07.08q-4.4,5.4-8.64,11C96,380.08,58.44,514.48,89.25,618.63q1.66,5.63,3.6,11.12c8.9,25.39,22.14,48.73,40.3,68.87a86.39,86.39,0,0,0,39.09,24.75c2.58.8,5.21,1.45,7.87,2,.75-12.65-.12-25.29-3.81-37.36-2-6.58-4.82-12.9-6.55-19.55a124.13,124.13,0,0,1-2.87-18.11q-2.38-22-4.76-44c-1-9-2-18.14-1.73-27.25a101.92,101.92,0,0,1,4.86-28.34c-1.44-2.66-1.69-5.84-1.85-8.89-.5-9.64-.72-19.28-.79-28.93-1.56,1.39-3.13,2.75-4.71,4.11L149.85,524a9.55,9.55,0,0,1-3.81,2.35c-3.51.86-6.62-2.26-8.89-5.08s-4.76-5.91-6-9.46a29.65,29.65,0,0,1-1.09-10.16c.08-4.39.3-8.77.53-13.15l1.89-36.64c.36-7,.72-13.94,1.35-20.89.45-5,1.09-10.08,3.66-14.35,4.83-8,15.19-10.79,24.6-10.11a3.53,3.53,0,0,1-.09-3,5.35,5.35,0,0,1,2.42-2L178.33,394a7.7,7.7,0,0,1,3.26-1.15,3.84,3.84,0,0,1,1.78.37l2.69-1.88a6.79,6.79,0,0,1,2-1.09,4.72,4.72,0,0,1,2.73.13,11,11,0,0,0,1.15-4.34,15.46,15.46,0,0,0-1.18-5.46,26.36,26.36,0,0,1-10.45-20.72c-3-1.68-6.86-2.62-8.08-6.16-.83-2.41.16-5.07-.18-7.58a6.17,6.17,0,0,1-1.48-2.34c-.86-2.49.26-5.27-.2-7.87-.26-1.43-1-2.83-.71-4.25a6.25,6.25,0,0,1,1.58-2.67l9.83-11.64c2.17-2.56,4.41-5.19,7.39-6.72,7.14-3.67,15.69,0,23.71,0,2.69,0,5.47-.42,8,.45a16.51,16.51,0,0,1,4.94,3.14l11,9c3.7,3,7.69,6.57,8.05,11.33a10.64,10.64,0,0,1-.62,4.25,11,11,0,0,1,2.27,5.66c.25,3.3-1.35,6.46-3.19,9.21a48.65,48.65,0,0,1-10,10.84,26.41,26.41,0,0,1-6.33,12.74,82.89,82.89,0,0,0,2.84,10.29,1.34,1.34,0,0,1,.07.18,5,5,0,0,1,2.6.91,14.08,14.08,0,0,1,2.16,2,3.14,3.14,0,0,1,1.46-1.22c1.48-.59,3.14.08,4.59.74,4.41,2,8.9,4.09,12.49,7.34a16,16,0,0,1,3.26,4.13,20.58,20.58,0,0,1,14.35,3.32c7.56,5.18,10.67,14.64,13.3,23.42q2.94,9.86,5.89,19.7c2.58,8.62,5.18,17.34,5.78,26.32.55,8.17-.57,16.35-1.69,24.46-1.55,11.23,2.1,23.54,2.15,34.87,0,2.91,0,5.86-.07,8.8a20.64,20.64,0,0,1,13.65-2.89,16,16,0,0,1,3.26-4.13c3.59-3.25,8.08-5.32,12.49-7.34,1.45-.66,3.11-1.33,4.59-.74a3.14,3.14,0,0,1,1.46,1.22,14.08,14.08,0,0,1,2.16-2,5,5,0,0,1,2.6-.91,1.34,1.34,0,0,1,.07-.18,82.89,82.89,0,0,0,2.84-10.29,26.41,26.41,0,0,1-6.33-12.74,48.65,48.65,0,0,1-10-10.84c-1.84-2.75-3.44-5.91-3.19-9.21a11,11,0,0,1,2.27-5.66,10.64,10.64,0,0,1-.62-4.25c.36-4.76,4.35-8.32,8.05-11.33l11-9a16.51,16.51,0,0,1,4.94-3.14c2.54-.87,5.32-.45,8-.45,8,0,16.57-3.65,23.71,0,3,1.53,5.22,4.16,7.39,6.72L393.77,467a6.25,6.25,0,0,1,1.58,2.67c.28,1.42-.45,2.82-.71,4.25-.46,2.6.66,5.38-.2,7.87a6.17,6.17,0,0,1-1.48,2.34c-.34,2.51.65,5.17-.18,7.58-1.22,3.54-5.06,4.48-8.08,6.16a26.36,26.36,0,0,1-10.45,20.72,15.46,15.46,0,0,0-1.18,5.46,11,11,0,0,0,1.15,4.34,4.72,4.72,0,0,1,2.73-.13,6.79,6.79,0,0,1,2,1.09l2.69,1.88a3.84,3.84,0,0,1,1.78-.37,7.7,7.7,0,0,1,3.26,1.15l13.88,7.43a8.82,8.82,0,0,1,1.7,1.13c.11-2.69.23-5.39.37-8.08l1.89-36.64c.36-7,.72-13.94,1.35-20.89.45-5,1.09-10.08,3.66-14.35,4.83-8,15.19-10.79,24.6-10.11a3.53,3.53,0,0,1-.09-3,5.35,5.35,0,0,1,2.42-2L450.33,438a7.7,7.7,0,0,1,3.26-1.15,3.84,3.84,0,0,1,1.78.37l2.69-1.88a6.79,6.79,0,0,1,2-1.09,4.72,4.72,0,0,1,2.73.13,11,11,0,0,0,1.15-4.34,15.46,15.46,0,0,0-1.18-5.46,26.36,26.36,0,0,1-10.45-20.72c-3-1.68-6.86-2.62-8.08-6.16-.83-2.41.16-5.07-.18-7.58a6.17,6.17,0,0,1-1.48-2.34c-.86-2.49.26-5.27-.2-7.87a25.28,25.28,0,0,1-.76-3.44,29,29,0,0,0-2.5,6.49c-1.41,5.67-1.16,11.61-2,17.38-.3,2-.87,4.14-2.56,5.2-1.31.81-3,.75-4.41,1.34-2.36,1-3.67,3.59-4,6.13s.07,5.1.07,7.66c0,6.69-3.21,13.61-9.05,16.87-7.69,4.29-17.24,1.45-25.55-1.47a22.55,22.55,0,0,0,9.54-6.62L392,427.63A58.66,58.66,0,0,0,406.6,418a12.41,12.41,0,0,0,3.72-4.88c1-2.8.07-6,1-8.81,1.55-4.8,7.44-6.63,10.44-10.68,2.63-3.54,2.72-8.29,2.71-12.7l-.05-16.78c0-4.83.31-10.39,4.16-13.32,4.29-3.28,10.37-1.41,15.77-1.45,5.69,0,11.11-2.36,16.77-3,5.34-.62,14.25,3.13,14.1,7.36a61.38,61.38,0,0,0,9,.94c2.69,0,5.47-.42,8,.45a16.51,16.51,0,0,1,4.94,3.14l11,9c3.7,3,7.69,6.57,8,11.33a10.64,10.64,0,0,1-.62,4.25,11,11,0,0,1,2.27,5.66c.25,3.3-1.35,6.46-3.19,9.21a48.65,48.65,0,0,1-10,10.84,26.41,26.41,0,0,1-6.33,12.74,82.89,82.89,0,0,0,2.84,10.29,1.34,1.34,0,0,1,.07.18,5,5,0,0,1,2.6.91,14.08,14.08,0,0,1,2.16,2,3.14,3.14,0,0,1,1.46-1.22c1.48-.59,3.14.08,4.59.74a55,55,0,0,1,11,6.11c0-.21,0-.41,0-.61.08-4.39.3-8.77.53-13.15l1.89-36.64c.36-7,.72-13.94,1.35-20.89.45-5,1.09-10.08,3.66-14.35,4.83-8,15.19-10.79,24.6-10.11a3.53,3.53,0,0,1-.09-3,5.35,5.35,0,0,1,2.42-2L571.33,332a7.7,7.7,0,0,1,3.26-1.15,3.84,3.84,0,0,1,1.78.37l2.69-1.88a6.79,6.79,0,0,1,2-1.09,4.72,4.72,0,0,1,2.73.13,11,11,0,0,0,1.15-4.34,15.46,15.46,0,0,0-1.18-5.46,26.36,26.36,0,0,1-10.45-20.72c-3-1.68-6.86-2.62-8.08-6.16-.83-2.41.16-5.07-.18-7.58a6.17,6.17,0,0,1-1.48-2.34c-.86-2.49.26-5.27-.2-7.87-.26-1.43-1-2.83-.71-4.25a6.25,6.25,0,0,1,1.58-2.67l9.83-11.64c2.17-2.56,4.41-5.19,7.39-6.72,7.14-3.67,15.69,0,23.71,0,2.69,0,5.47-.42,8,.45a16.51,16.51,0,0,1,4.94,3.14l11,9c3.7,3,7.69,6.57,8,11.33a10.64,10.64,0,0,1-.62,4.25,11,11,0,0,1,2.27,5.66c.25,3.3-1.35,6.46-3.19,9.21a48.65,48.65,0,0,1-10,10.84,26.41,26.41,0,0,1-6.33,12.74,82.89,82.89,0,0,0,2.84,10.29,1.34,1.34,0,0,1,.07.18,5,5,0,0,1,2.6.91,14.08,14.08,0,0,1,2.16,2,3.14,3.14,0,0,1,1.46-1.22c1.48-.59,3.14.08,4.59.74,4.41,2,8.9,4.09,12.49,7.34a16,16,0,0,1,3.26,4.13,20.58,20.58,0,0,1,14.35,3.32c7.56,5.18,10.67,14.64,13.3,23.42q2.94,9.86,5.89,19.7c2.58,8.62,5.18,17.34,5.78,26.32.51,7.64-.44,15.28-1.48,22.87.25-.26.5-.51.78-.76,3.59-3.25,8.08-5.32,12.49-7.34,1.45-.66,3.11-1.33,4.59-.74a3.14,3.14,0,0,1,1.46,1.22,14.08,14.08,0,0,1,2.16-2,5,5,0,0,1,2.6-.91,1.34,1.34,0,0,1,.07-.18,82.89,82.89,0,0,0,2.84-10.29,26.41,26.41,0,0,1-6.33-12.74,48.65,48.65,0,0,1-10-10.84c-1.84-2.75-3.44-5.91-3.19-9.21a11,11,0,0,1,2.27-5.66,10.64,10.64,0,0,1-.62-4.25c.36-4.76,4.35-8.32,8-11.33l11-9a16.51,16.51,0,0,1,4.94-3.14c2.54-.87,5.32-.45,8-.45a61.38,61.38,0,0,0,9-.94c-.15-4.23,8.76-8,14.1-7.36,5.65.65,11.08,3,16.77,3,5.4,0,11.48-1.83,15.77,1.45,3.85,2.93,4.17,8.49,4.16,13.32l-.05,16.78c0,4.41.08,9.16,2.71,12.7,2.86,3.86,8.33,5.7,10.18,10,2.26-5.81,5.32-11.2,10.38-14.67a20.58,20.58,0,0,1,14.35-3.32,16,16,0,0,1,3.26-4.13c3.59-3.25,8.08-5.32,12.49-7.34,1.45-.66,3.11-1.33,4.59-.74a3.14,3.14,0,0,1,1.46,1.22,14.08,14.08,0,0,1,2.16-2,5,5,0,0,1,2.6-.91,1.34,1.34,0,0,1,.07-.18,82.89,82.89,0,0,0,2.84-10.29,26.41,26.41,0,0,1-6.33-12.74,48.65,48.65,0,0,1-10-10.84c-1.84-2.75-3.44-5.91-3.19-9.21a11,11,0,0,1,2.27-5.66,10.64,10.64,0,0,1-.62-4.25c.36-4.76,4.35-8.32,8-11.33l11-9a16.51,16.51,0,0,1,4.94-3.14c2.54-.87,5.32-.45,8-.45a61.38,61.38,0,0,0,9-.94c-.15-4.23,8.76-8,14.1-7.36,5.65.65,11.08,3,16.77,3,5.4,0,11.48-1.83,15.77,1.45,3.85,2.93,4.17,8.49,4.16,13.32l-.05,16.78c0,4.41.08,9.16,2.71,12.7,3,4.05,8.89,5.88,10.44,10.68.9,2.83,0,6,1,8.81A12.41,12.41,0,0,0,946.4,351a57.94,57.94,0,0,0,7.15,5.52,11.91,11.91,0,0,1,1.89-3.68,10.64,10.64,0,0,1-.62-4.25c.36-4.76,4.35-8.32,8-11.33l11-9a16.51,16.51,0,0,1,4.94-3.14c2.54-.87,5.32-.45,8-.45,8,0,16.57-3.65,23.71,0,3,1.53,5.22,4.16,7.39,6.72l9.83,11.64a6.25,6.25,0,0,1,1.58,2.67c.28,1.42-.45,2.82-.71,4.25-.46,2.6.66,5.38-.2,7.87a6.17,6.17,0,0,1-1.48,2.34c-.34,2.51.65,5.17-.18,7.58-1.22,3.54-5.06,4.48-8.08,6.16a26.36,26.36,0,0,1-10.45,20.72,15.46,15.46,0,0,0-1.18,5.46,11,11,0,0,0,1.15,4.34,4.72,4.72,0,0,1,2.73-.13,6.79,6.79,0,0,1,2,1.09l2.69,1.88a3.84,3.84,0,0,1,1.78-.37,7.7,7.7,0,0,1,3.26,1.15l13.88,7.43a5.35,5.35,0,0,1,2.42,2,3.53,3.53,0,0,1-.09,3c9.41-.68,19.77,2.11,24.6,10.11,2.57,4.27,3.21,9.39,3.66,14.35.63,6.95,1,13.92,1.35,20.89l1.89,36.64c.23,4.38.45,8.76.53,13.15a29.65,29.65,0,0,1-1.09,10.16c-1.21,3.55-3.61,6.54-6,9.46s-5.38,5.94-8.89,5.08a9.55,9.55,0,0,1-3.81-2.35l-8.05-6.91c-1.58-1.36-3.15-2.72-4.71-4.11-.07,9.65-.29,19.29-.79,28.93-.16,3.05-.41,6.23-1.85,8.89a101.92,101.92,0,0,1,4.86,28.34,179.37,179.37,0,0,1-1.32,23.5c.84-1.79,1.68-3.58,2.53-5.41C1083.19,518.34,1133.3,384.52,1116.24,290.19Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M163.89,466.87l-2.55,9.9c.5-.63,1-1.25,1.51-1.87a17.5,17.5,0,0,1,1.42-7.22c1.07-2.16,2.85-3.86,4.33-5.75a8.33,8.33,0,0,1-.67.5,11.07,11.07,0,0,0-3,1.89A6.24,6.24,0,0,0,163.89,466.87Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M777.15,511.9c.5.62,1,1.24,1.51,1.87l-2.55-9.9a6.24,6.24,0,0,0-1.08-2.55,11.07,11.07,0,0,0-3-1.89,8.33,8.33,0,0,1-.67-.5c1.48,1.89,3.26,3.59,4.33,5.75A17.5,17.5,0,0,1,777.15,511.9Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M934.17,572.34c.3-.27.61-.52.93-.77-.89-1.22-1.75-2.47-2.54-3.77a1,1,0,0,0-.08-.14c.39,1.24.81,2.47,1.28,3.69C933.89,571.68,934,572,934.17,572.34Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M673.48,590.66c.39,1.24.81,2.47,1.28,3.69.13.33.27.66.41,1,.3-.27.61-.52.93-.77-.89-1.22-1.75-2.47-2.54-3.77A1,1,0,0,0,673.48,590.66Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M759.7,396.88a26.36,26.36,0,0,1-10.45,20.72,15.46,15.46,0,0,0-1.18,5.46,11,11,0,0,0,1.15,4.34,4.72,4.72,0,0,1,2.73-.13,6.79,6.79,0,0,1,2,1.09l2.69,1.88a3.84,3.84,0,0,1,1.78-.37,7.7,7.7,0,0,1,3.26,1.15l13.88,7.43a5.35,5.35,0,0,1,2.42,2,3.53,3.53,0,0,1-.09,3,36.49,36.49,0,0,1,8.91.43,148.53,148.53,0,0,1,4.15-16.53,20.61,20.61,0,0,1-5.1-13.72c0-2.56.41-5.13.07-7.66s-1.65-5.16-4-6.13c-1.43-.59-3.1-.53-4.41-1.34-1.69-1.06-2.26-3.22-2.56-5.2-.87-5.77-.62-11.71-2-17.38a29,29,0,0,0-2.5-6.49,25.28,25.28,0,0,1-.76,3.44c-.46,2.6.66,5.38-.2,7.87a6.17,6.17,0,0,1-1.48,2.34c-.34,2.51.65,5.17-.18,7.58C766.56,394.26,762.72,395.2,759.7,396.88Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M814.29,479.23c-2.36,16.14-4.64,33-.61,48.64a5.86,5.86,0,0,1,1.53-2.5c2.66-3.27,3.71-7.54,4.5-11.68,4.86-25.57,2.52-51.76,1.42-77.88L819,438.27A11.82,11.82,0,0,0,817,441a10.21,10.21,0,0,0-.81,3.75,47.06,47.06,0,0,0,.31,9.19A49.59,49.59,0,0,1,815.34,474,37.58,37.58,0,0,0,814.29,479.23Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M799.07,562a6.13,6.13,0,0,1-5.11,1.31,9.55,9.55,0,0,1-3.81-2.35l-8-6.91c-1.58-1.36-3.15-2.72-4.71-4.11-.07,9.65-.29,19.29-.79,28.93-.16,3.05-.41,6.23-1.85,8.89a101.92,101.92,0,0,1,4.86,28.34c.24,9.11-.74,18.2-1.73,27.25q-2.37,22-4.76,44a124.13,124.13,0,0,1-2.87,18.11c-1.38,5.31-3.45,10.41-5.25,15.59l10.21-.11,13-.14h1.6l22-.24a.13.13,0,0,0,0-.06c1.7-9.63,6.28-19,5.37-28.68-.6-6.51-3.62-12.5-5.7-18.69-9.08-27.06,0-57.22-6.57-85-1.51-6.38-3.79-13.27-1-19.22l-4.17-1.28c.57-1.31,1.15-2.63,1.73-3.94A10.3,10.3,0,0,1,799.07,562Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M718.83,701.28q.06,10.14.13,20.28h.44Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M977.83,678.28q.1,15.3.2,30.6l.66-.38Q978.25,693.4,977.83,678.28Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M953.59,362.13l-1.69.34a22,22,0,0,0,3.14,3A16.72,16.72,0,0,1,953.59,362.13Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M859.83,641.28l.3,44.06a51.92,51.92,0,0,1-.67,10.65c-.6,2.93-1.7,5.74-2.33,8.67-.89,4.2-.78,8.53-.74,12.82,0,.87,0,1.73,0,2.59l5.67-.06Q860.95,680.65,859.83,641.28Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M1036.15,488.9c.5.62,1,1.24,1.51,1.87l-2.55-9.9a6.24,6.24,0,0,0-1.08-2.55,11.07,11.07,0,0,0-3-1.89,8.33,8.33,0,0,1-.67-.5c1.48,1.89,3.26,3.59,4.33,5.75A17.5,17.5,0,0,1,1036.15,488.9Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M900.7,336.88a26.36,26.36,0,0,1-10.45,20.72,15.46,15.46,0,0,0-1.18,5.46,11,11,0,0,0,1.15,4.34,4.72,4.72,0,0,1,2.73-.13,6.79,6.79,0,0,1,2,1.09l2.69,1.88a3.84,3.84,0,0,1,1.78-.37,7.7,7.7,0,0,1,3.26,1.15l13.88,7.43a5.35,5.35,0,0,1,2.42,2,3.53,3.53,0,0,1-.09,3c9.41-.68,19.77,2.11,24.6,10.11,2.57,4.27,3.21,9.39,3.66,14.35.08.92.15,1.83.22,2.74,3.43-2.8,7.53-4.71,11.57-6.56,1.45-.66,3.11-1.33,4.59-.74a3.14,3.14,0,0,1,1.46,1.22,14.08,14.08,0,0,1,2.16-2,5,5,0,0,1,2.6-.91,1.34,1.34,0,0,1,.07-.18,82.89,82.89,0,0,0,2.84-10.29,26.41,26.41,0,0,1-6.33-12.74,48.87,48.87,0,0,1-8.14-8.31c-7.47,2.42-15.59,4.1-22.29.36-5.84-3.26-9-10.18-9-16.87,0-2.56.41-5.13.07-7.66s-1.65-5.16-4-6.13c-1.43-.59-3.1-.53-4.41-1.34-1.69-1.06-2.26-3.22-2.56-5.2-.87-5.77-.62-11.71-2-17.38a29,29,0,0,0-2.5-6.49,25.28,25.28,0,0,1-.76,3.44c-.46,2.6.66,5.38-.2,7.87a6.17,6.17,0,0,1-1.48,2.34c-.34,2.51.65,5.17-.18,7.58C907.56,334.26,903.72,335.2,900.7,336.88Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#f2f2f2"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M253.38,346H804.78a18.88,18.88,0,0,1,18.88,18.88v66.33a0,0,0,0,1,0,0H234.5a0,0,0,0,1,0,0V364.9A18.88,18.88,0,0,1,253.38,346Z",
  fill: "#3f3d56"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M253.38,346H804.78a18.88,18.88,0,0,1,18.88,18.88v66.33a0,0,0,0,1,0,0H234.5a0,0,0,0,1,0,0V364.9A18.88,18.88,0,0,1,253.38,346Z",
  opacity: 0.1
});

var _ref43 = /*#__PURE__*/React.createElement("polygon", {
  points: "703.76 423.32 703.76 547 680.01 547.26 678.33 547.28 657.2 547.51 656.55 547.51 641.74 547.67 614.8 547.97 526.32 548.93 513.91 549.06 489.54 549.33 488.42 549.34 467.62 549.57 410.06 550.19 396.53 550.34 354.4 550.8 354.4 423.32 703.76 423.32",
  fill: "#3f3d56"
});

var _ref44 = /*#__PURE__*/React.createElement("polygon", {
  points: "703.76 423.32 703.76 547 680.01 547.26 678.33 547.28 657.2 547.51 656.55 547.51 641.74 547.67 614.8 547.97 526.32 548.93 513.91 549.06 489.54 549.33 488.42 549.34 467.62 549.57 410.06 550.19 396.53 550.34 354.4 550.8 354.4 423.32 703.76 423.32",
  opacity: 0.1
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M234.5,422.71H823.66a0,0,0,0,1,0,0v14.55a19.53,19.53,0,0,1-19.53,19.53H255.23a20.73,20.73,0,0,1-20.73-20.73V422.71A0,0,0,0,1,234.5,422.71Z",
  fill: "#3f3d56"
});

var _ref46 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 412.83,
  cy: 430.62,
  rx: 42,
  ry: 9.13,
  fill: "#539dfe"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M487.73,604.67l-.83-43.47c-.18-9.72.17-20.74,7.4-27.25,4.57-4.11,11.43-5.88,14.3-11.31,1.56-3,1.59-6.47,1.58-9.81q0-29.6-.11-59.18",
  transform: "translate(-78.34 -173.03)",
  fill: "none",
  stroke: "#539dfe",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 420.74,
  y: 262.03,
  width: 19.48,
  height: 37.74,
  rx: 8,
  fill: "#539dfe"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M663.71,535.66c-6.4-7.47-13.23-14.55-20.06-21.63L629.8,499.66l-12.58-13.05-60.53-62.78c-7.36-7.64-15.08-15.52-25-19.26s-22.76-2.07-28.77,6.68a12.63,12.63,0,0,0-2.31,9.61c.7,3.25,3,5.9,5.49,8.15,11.8,10.78,27.72,15.55,41.81,23.1a49.55,49.55,0,0,1,12.82,9.18,63.81,63.81,0,0,1,8,11.37l35.39,59.05a82.11,82.11,0,0,0,7.48,11c2.26,2.66,4.85,5,7.24,7.57,5.65,6,10.09,13.11,15.52,19.35,7.55,8.7,16.88,15.64,26.13,22.51,1.91,1.42,4,2.89,6.35,3,3.11.16,5.8-2,8.13-4.07,3.79-3.35,11.49-8.16,13.57-12.82,1.83-4.13-1.4-8.3-3.35-11.94A174.75,174.75,0,0,0,663.71,535.66Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#fbbebe"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M693.14,721l-88.48,1-12.41.13-24.37.27h-1.12l-20.8.23A106.93,106.93,0,0,1,553,705.13a67.77,67.77,0,0,1,6.39-10c4.46.4,8.91.76,13.37,1.12q15.5,1.21,31,2.21c26.16,1.72,52.27,3.2,78.52,5.54,1.77.16,3.66.37,5,1.52a8.11,8.11,0,0,1,1.83,2.78A56.67,56.67,0,0,1,693.14,721Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#3f3d56"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M631.68,478.94c22.8-7.26,33.72-11.35,54-24.12-4.43.74,2-4.62-2.43-5.23s-8.89-2.8-11.15-6.68c-1.47-2.52-1.9-5.49-2.29-8.38l-2.16-15.83c.26,1.88-41.29,2.12-41.59,13.83-.16,6.12,4.19,13.11,5.32,19.17A79.37,79.37,0,0,1,631.68,478.94Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#fbbebe"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M631.68,478.94c22.8-7.26,33.72-11.35,54-24.12-4.43.74,2-4.62-2.43-5.23s-8.89-2.8-11.15-6.68c-1.47-2.52-1.9-5.49-2.29-8.38l-2.16-15.83c.26,1.88-41.29,2.12-41.59,13.83-.16,6.12,4.19,13.11,5.32,19.17A79.37,79.37,0,0,1,631.68,478.94Z",
  transform: "translate(-78.34 -173.03)",
  opacity: 0.1
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M725.07,621.92c0,2.64,0,5.27-.13,7.9-.5,11.3-2.3,22.56-3.41,33.83-1.88,19-1.8,38-1.45,57.05l-26.94.29-88.48,1-12.41.13-24.37.27c-.23-.54-.48-1.07-.75-1.58a.19.19,0,0,0,0-.07c-3.22-6.25-9.07-10.6-14.09-15.58a36,36,0,0,1-6.23-7.71c11-18.94,21.11-38.66,28.35-59.35,1-2.75,1.86-5.53,3-8.25a42.45,42.45,0,0,1,2.55-5.42c1.77-3.06,4-5.88,5.3-9.19a30.62,30.62,0,0,0,1.54-9.09q.06-.93.09-1.86.18-4,.15-7.91c0-.21,0-.41,0-.61q0-4.75-.34-9.48c-.49-7.09-1.43-14.21-.56-21.26,1.64-13.28,9.48-24.77,15.08-37,.54-1.16,1.06-2.31,1.54-3.48.75-1.8,1.44-3.64,2.1-5.49,3.77-10.66,6.56-21.92,13.46-30.59.58-.74,1.22-1.47,1.87-2.18,2.9-3.1,6.44-5.81,8.15-9.69s2.21-8.81-1.91-9.8q2.89-2.06,5.5-3.86c13.47-9.26,22.1-13.57,40-17.51.39-.09.78-.16,1.17-.23a8,8,0,0,1,3.45,0,10.08,10.08,0,0,1,3.26,1.74c10.83,7.6,21,13.46,25.5,25.9,1.57,4.33,6.55,11.29,7.3,15.83,1.78,10.73,6.41,20.41,9.55,30.43A58,58,0,0,1,726,537.52c-.24,17.55-3.65,35-3.15,52.53.06,1.9.16,3.8.29,5.69,0,.2,0,.41,0,.61.18,2.64.43,5.28.67,7.91C724.38,610.14,725,616,725.07,621.92Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#565171"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M643.17,578.11c0,.12,0,.26,0,.38-.23,3.69-.45,7.39-.78,11.09,0,.64-.11,1.29-.17,1.95-.14,1.4-.28,2.81-.45,4.21,0,.2,0,.4-.07.61-.32,2.65-.71,5.29-1.21,7.91s-1.12,5.38-1.87,8c-1.71,5.93-4.08,11.66-6,17.53-.64,2-1.24,4-1.74,6-.84,3.4-1.4,6.85-2.39,10.2a81.19,81.19,0,0,1-5.18,12.29l-19.52,40.11q-5.31,10.9-10.62,21.79c-.29.61-.59,1.22-.89,1.84l-24.37.27h-1.12c.13-.54.25-1.06.37-1.59q2.83-12.27,5.65-24.53T578.35,672q2-8.84,4.07-17.67,2.22-9.72,4.47-19.46c.39-1.69.78-3.37,1.16-5.06,1.84-7.89,3.74-15.77,6-23.54.19-.67.4-1.35.59-2,.82-2.66,1.67-5.3,2.59-7.91.06-.21.13-.42.2-.61a164.38,164.38,0,0,1,7.82-18.82c.06-.15.13-.27.2-.42s0,0,0,0c.83-1.68,1.71-3.34,2.61-5,2-3.61,3.7-8.6,8.17-9.32,4-.64,9.89,1.6,14.62,3.24h0c1.29.45,2.47.84,3.52,1.13,3,.83,6.28,1.9,7.84,4.59C643.44,573.19,643.32,575.74,643.17,578.11Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#fbbebe"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M620.19,495.09c-5,5.09-7.89,11.92-10.07,18.74A135.26,135.26,0,0,0,605.2,575c.34,2.21.87,4.65,2.72,5.92,2.08,1.43,5.09.67,7-1.05s2.83-4.17,3.76-6.52c1.63,3.87,3.35,7.86,6.4,10.75,6.33,6,16.48,5.68,23.79,10.45a594.56,594.56,0,0,0,26.62-63.67,35.38,35.38,0,0,0,2.45-10.33,24.11,24.11,0,0,0-1.79-9.32c-4-10.41-13.32-18.41-24-21.5C641.9,486.76,628.07,487.13,620.19,495.09Z",
  transform: "translate(-78.34 -173.03)",
  opacity: 0.1
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M619,492.65c-5,5.09-7.89,11.93-10.08,18.74a135.14,135.14,0,0,0-4.91,61.2c.33,2.21.87,4.65,2.71,5.91,2.08,1.44,5.09.67,6.95-1s2.84-4.16,3.76-6.52c1.64,3.87,3.35,7.86,6.4,10.76,6.33,6,16.48,5.68,23.8,10.44a594.83,594.83,0,0,0,26.61-63.67,34.7,34.7,0,0,0,2.45-10.32,24,24,0,0,0-1.79-9.33c-4-10.41-13.32-18.4-24-21.5C640.68,484.33,626.85,484.69,619,492.65Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#565171"
});

var _ref57 = /*#__PURE__*/React.createElement("circle", {
  cx: 560.73,
  cy: 229.16,
  r: 42.6,
  fill: "#fbbebe"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M596.53,383A17.93,17.93,0,0,1,607,377.16c-.36,4.33,3.31,8,7.26,9.84s8.39,2.41,12.28,4.33c6.94,3.42,12.21,10.95,19.94,11.23,2.68.09,6-.5,7.52,1.68a6.41,6.41,0,0,1,.88,3.21l.74,8.08c2.14,1.25,4.75-.21,7.16-.77a9.71,9.71,0,0,1,11,13.54,19.69,19.69,0,0,0,22.06-23.51,17.54,17.54,0,0,1-.77-5c.31-3.86,4-6.41,6.12-9.65,2.93-4.5,2.71-10.48.75-15.48s-5.42-9.23-8.83-13.37L681,346.57c-5.59-6.78-12.24-14.12-21-14.57-6.21-.31-12.05,3-18.24,3.58-9,.85-18.45-4-26.81-.61-6,2.43-9.56,8.4-12.74,14-2.66,4.67-5.35,9.43-6.46,14.68-1.81,8.54.75,17.45-.23,26.12Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#3f3d56"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M105.22,658c2-1.31,4-2.54,5.91-3.74.9-.56,1.79-1.14,2.67-1.75a82.32,82.32,0,0,0,11.93-9.81c.26-.24.52-.51.78-.77l.18-.18a22.8,22.8,0,0,0,4.78-6.4c1.58-3.52,1.54-7.52,1.44-11.37q-.33-12.25-1-24.5c-.17-3.15-.37-6.3-.58-9.45-.1-1.52-.21-3-.32-4.54",
  transform: "translate(-78.34 -173.03)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M145.51,584.74a14,14,0,0,0-7-11.5l-3.14,6.22.1-7.53a14,14,0,1,0,10,12.81Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#539dfe"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M121.16,668.43l-6.58,5.35q-4.6-7-8.56-14.35a11.35,11.35,0,0,1,1.32-.13A14,14,0,0,1,121.16,668.43Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#539dfe"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M122,673.33a14,14,0,0,1-1.56,6.4,12.61,12.61,0,0,1-.84,1.42l-.9-1.26c-1.17-1.65-2.32-3.31-3.44-5Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#539dfe"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M113.55,652.49A14,14,0,0,1,109.1,625l-.08,5.78,3.18-6.29h0a14,14,0,0,1,14.67,13.37,13.84,13.84,0,0,1-.6,4.79A14.05,14.05,0,0,1,113.55,652.49Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#539dfe"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M147.62,629.81a14,14,0,1,1,6.21-26.26l-2.48,6.79,5.1-4.89a14,14,0,0,1,4.53,9.69,13.72,13.72,0,0,1-.35,3.86A14,14,0,0,1,147.62,629.81Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#539dfe"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M143.62,588.48c-3.24.36-6.39,1.37-9.64,1.57s-6.82-.58-8.88-3.11c-1.1-1.36-1.66-3.08-2.59-4.56a10,10,0,0,0-3.54-3.33,14,14,0,1,0,26.24,9.31C144.68,588.39,144.15,588.42,143.62,588.48Z",
  transform: "translate(-78.34 -173.03)",
  opacity: 0.1
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M147.62,629.81a14,14,0,0,1-13.35-20,10.27,10.27,0,0,1,2.82,2.83c1,1.51,1.61,3.25,2.78,4.64,2.19,2.57,5.92,3.41,9.31,3.25s6.66-1.11,10-1.42c.47,0,.94-.08,1.42-.09A14,14,0,0,1,147.62,629.81Z",
  transform: "translate(-78.34 -173.03)",
  opacity: 0.1
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M113.55,652.49a14,14,0,0,1-13.46-19.76,11.31,11.31,0,0,1,3,2.85c1.09,1.54,1.77,3.31,3,4.73,2.37,2.64,6.35,3.57,9.93,3.48s6.83-.93,10.28-1.19A14.05,14.05,0,0,1,113.55,652.49Z",
  transform: "translate(-78.34 -173.03)",
  opacity: 0.1
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M120.48,679.73a12.61,12.61,0,0,1-.84,1.42l-.9-1.26Z",
  transform: "translate(-78.34 -173.03)",
  fill: "#539dfe"
});

var SvgSpeaker = function SvgSpeaker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bbd2572f-7b08-4c5d-b64e-2e695104dd4a",
    "data-name": "Layer 1",
    viewBox: "0 0 1041.32 553.94",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeaker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speaker.0cb529ad.svg";
export { ForwardRef as ReactComponent };